module.exports = __webpack_public_path__ + "media/images/pitches/screenshot-message-7c0d25d74f557bd4665c545e55599e5f.png";